import { SearchParam } from '../param';
import isNil from '../../helpers/is-nil';

type QueryParamTuple = [SearchParam, undefined | null | string | string[]];

export const buildQueryParams = (...tuples: QueryParamTuple[]): string => {
  const searchParams = new URLSearchParams();
  tuples.forEach(([param, value]) => {
    if (isNil(value)) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(param, item);
      });
    } else {
      searchParams.append(param, value);
    }
  });
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};
